import { FC, useState } from "react"
import { Container, Item } from "./style"
import { TabMode } from "widgets/mobileIndex/lib/hooks/useMobileIndex";

interface MobileIndexSwitchersProps {
  tabMode: TabMode;
  setTabMode: React.Dispatch<React.SetStateAction<TabMode>>;
}

export const MobileIndexSwitchers: FC<MobileIndexSwitchersProps> = ({
  tabMode,
  setTabMode
}) => {

  const [ items ] = useState([
    {
      name: 'Ожидаются',
      value: 'wait' 
    },
    {
      name: 'Разместить',
      value: 'place'
    },
    {
      name: 'В зале',
      value: 'sitting'
    },
  ] as const)

  return (
    <>
      <Container
        $columns={items.length}
        $rows={1}
        $activeIndex={items.findIndex(el=>el.value===tabMode)}
      >
        {items.map((item, index) => {
          return (
            <Item 
              key={index}
              $active={item.value === tabMode}
              onClick={() => {setTabMode(item.value)}}
            >{item.name}</Item>
          )
        })}
        
      </Container>
    </>
  )
}